"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HighlightedEventCard = HighlightedEventCard;
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _Close2 = _interopRequireDefault(require("@mui/icons-material/Close"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _useMediaQuery2 = _interopRequireDefault(require("@mui/material/useMediaQuery"));
var _styles = require("@mui/material/styles");
var _moment = _interopRequireDefault(require("moment"));
var _notistack = require("notistack");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _trophy = _interopRequireDefault(require("../assets/images/trophy.svg"));
var _hooks = require("../hooks");
var _services = require("../services");
var _button = require("./button");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const now = (0, _moment.default)();
const defaultColor = '#FCCE2C';
function HighlightedEventCard({
  Button: _Button,
  hasGeogroups,
  partner,
  geogroup,
  highlightedEvent,
  highlightedEventChallenge,
  displayButtonProps,
  onJoined,
  onClose
}) {
  const _theme = (0, _styles.useTheme)();
  const [theme, setTheme] = (0, _react.useState)(_theme);
  const [joiningEvent, setJoiningEvent] = (0, _react.useState)(false);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    enqueueSnackbar
  } = (0, _notistack.useSnackbar)();
  const smallDevice = (0, _useMediaQuery2.default)(theme.breakpoints.down('md'));
  const {
    cancellablePromise,
    cancelPromises
  } = (0, _hooks.useCancellablePromise)();
  (0, _react.useEffect)(() => {
    return () => cancelPromises();
  }, []);
  (0, _react.useEffect)(() => {
    if (highlightedEvent?.primaryColor) {
      setTheme((0, _styles.createTheme)({
        ..._theme,
        palette: {
          ..._theme.palette,
          primary: {
            main: highlightedEvent.primaryColor
          }
        }
      }));
    }
  }, [highlightedEvent]);
  async function handleEventJoin() {
    if (!geogroup || !highlightedEvent) return;
    setJoiningEvent(true);
    try {
      const challenge = await cancellablePromise(_services.GeogroupService.addChallenge({
        code: partner?.code,
        geoGroupId: geogroup.id
      }, {
        event: highlightedEvent.id
      }));
      await cancellablePromise(_services.UserService.joinChallenge({
        geogroupId: geogroup.id,
        challengeId: challenge.id
      }));
      enqueueSnackbar(t('commons.highlighted_event_card.success'));
      onJoined?.(challenge);
    } catch (err) {
      if (!(err instanceof Error) || err?.name !== 'CancelledPromiseError') {
        enqueueSnackbar(t('commons.highlighted_event_card.server_error'), {
          variant: 'error'
        });
        setJoiningEvent(false);
      }
    }
  }
  if (!highlightedEvent || highlightedEvent.endDate.isBefore(now) || highlightedEventChallenge === undefined) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  const Button = _Button || _button.Button;
  const row = !smallDevice;
  const secondaryColor = highlightedEvent.secondaryColor || defaultColor;
  return /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bgcolor: (0, _styles.lighten)(secondaryColor, 0.5),
    borderRadius: 2,
    flexShrink: 0,
    overflow: "hidden",
    position: "relative",
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    left: 0,
    position: "absolute",
    right: 0,
    top: 0,
    zIndex: 1
  }, /*#__PURE__*/_react.default.createElement(TopIllustration, {
    color: secondaryColor
  })), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bottom: 0,
    display: "flex",
    justifyContent: "flex-end",
    left: 0,
    position: "absolute",
    right: 0,
    zIndex: 1
  }, /*#__PURE__*/_react.default.createElement(BottomIllustration, {
    color: secondaryColor
  })), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: row ? 'center' : 'flex-start',
    display: "flex",
    gap: 2,
    padding: 2,
    position: "relative",
    zIndex: 2
  }, highlightedEvent.challengeTemplate?.icon ? /*#__PURE__*/_react.default.createElement("img", {
    src: highlightedEvent.challengeTemplate.icon,
    style: {
      flexShrink: 0
    },
    width: 100
  }) : /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    bgcolor: "#fff",
    borderRadius: 2,
    display: "flex",
    flexShrink: 0,
    height: 50,
    justifyContent: "center",
    width: 100
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _trophy.default,
    width: 50
  })), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: row ? 'center' : 'flex-start',
    display: "flex",
    flexDirection: row ? 'row' : 'column',
    flexGrow: 1,
    gap: row ? 2 : 1
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 700
  }, geogroup !== null && highlightedEventChallenge ? t('commons.highlighted_event_card.title_joined', {
    title: highlightedEvent.title
  }) : t('commons.highlighted_event_card.title_not_joined', {
    title: highlightedEvent.title
  })), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, highlightedEvent.subtitle || (geogroup === null && hasGeogroups ? t('commons.highlighted_event_card.event_indications_description') : t('commons.highlighted_event_card.description')))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    flexShrink: 0,
    gap: 2
  }, highlightedEvent.detailsUrl && /*#__PURE__*/_react.default.createElement(Button, {
    color: "primary",
    href: highlightedEvent.detailsUrl,
    rel: "noreferrer",
    size: "medium",
    target: "_blank",
    variant: geogroup === null && !hasGeogroups ? 'contained' : 'text'
  }, geogroup === null && !hasGeogroups ? t('commons.highlighted_event_card.actions.join') : t('commons.actions.learn_more')), geogroup && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, highlightedEventChallenge ? /*#__PURE__*/_react.default.createElement(Button, _extends({
    disableElevation: true,
    color: "primary",
    size: "medium",
    variant: "contained"
  }, displayButtonProps), t('commons.highlighted_event_card.actions.display')) : /*#__PURE__*/_react.default.createElement(Button, {
    disableElevation: true,
    color: "primary",
    disabled: joiningEvent,
    onClick: handleEventJoin,
    size: "medium",
    variant: "contained"
  }, t('commons.highlighted_event_card.actions.join'))))), onClose && /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    title: t('commons.actions.close')
  }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    onClick: onClose,
    size: "small",
    style: {
      alignSelf: 'flex-start',
      flexShrink: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_Close2.default, {
    fontSize: "small"
  }))))));
}
function BottomIllustration({
  color
}) {
  return /*#__PURE__*/_react.default.createElement("svg", {
    fill: "none",
    height: "68",
    viewBox: "0 0 220 68",
    width: "220",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M134.5 30C57.943 10.9316 42.4905 47.4401 0 68H220V0C179.5 33.5 161 36.6005 134.5 30Z",
    fill: color || defaultColor
  }));
}
function TopIllustration({
  color
}) {
  return /*#__PURE__*/_react.default.createElement("svg", {
    fill: "none",
    height: "87",
    viewBox: "0 0 162 87",
    width: "162",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0.0107666 87C93.2275 65.0854 65.9998 29.5 116.5 13C128.572 9.05549 148.5 16.5 161.5 5.84891e-05C143.532 5.02023e-05 13 5.05447e-05 0.00390625 0.000143366C0.00512029 48.5527 0.0105413 11.104 0.0107666 87Z",
    fill: color
  }));
}